import { render, staticRenderFns } from "./VariableSelector.vue?vue&type=template&id=37b56db0&scoped=true&"
import script from "./VariableSelector.vue?vue&type=script&lang=js&"
export * from "./VariableSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b56db0",
  null
  
)

export default component.exports